import React from 'react';

export default function template(context) {
    const calc = context.calc,
        model = calc.state.model;

    return (
        <React.Fragment>
            <div className="main-result">
                <p className="center-text monthly-payment">
                    {calc.l10n("CALCULATOR_REQUIRED_PAYMENT")}
                </p>
                <p className="monthly-payment-value center-text bold">{model.getRequiredPayment().toLocaleString('RU-ru', {
                    style: 'currency',
                    currency: 'UAH',
                })} <span className="asterix">*</span></p>
            </div>

            <div className={`loan-conditions ${calc.props.type}`}>
                <div className="loan-conditions-item">
                    <p className="condition-text">{calc.l10n('CALCULATOR_CREDIT_SUM')}</p>
                    <p className="bold">{model.getCreditSum().toLocaleString('RU-ru', {
                        style: 'currency',
                        currency: 'UAH',
                    })}</p>
                </div>
                <div className="loan-conditions-item">
                    <p className="condition-text">
                        {calc.l10n('CALCULATOR_CREDIT_FORM')}
                    </p>
                    <p className="bold">
                        {model.getCreditTerm()} {calc.l10n('CALCULATOR_DAY')}</p>
                </div>
                <div className="loan-conditions-item">
                    <p className="condition-text">{calc.l10n('CALCULATOR_OVERPAYMENT')}</p>
                    <p className="bold">{model.getOverpayment().toLocaleString('RU-ru', {
                        style: 'currency',
                        currency: 'UAH',
                    })}</p>
                </div>
                <div className="loan-conditions-item">
                    <p className="condition-text">{calc.l10n('CALCULATOR_REAL_INTEREST_RATE')}</p>
                    <p className="bold">{model.realInterestRate()}%</p>
                </div>
                <div className="loan-conditions-item">
                    <p className="condition-text">{calc.l10n('CALCULATOR_TOTAL_COST')}</p>
                    <p className="bold">{model.mainSumOfCredit().toLocaleString('RU-ru', {
                        style: 'currency',
                        currency: 'UAH',
                    })}</p>
                </div>
            </div>
            <div className="line" />
            <div className="disclaimer">{calc.l10n('CALCULATOR_DISCLAIMER')}</div>
        </React.Fragment>
    );
}
